<template>
    <b-card class="formations registrable-controllers">
        <b-card title="Registrable Controllers" class="mt-2 bordered-card registrable-controllers-section">
            <registrable-controller-index
                v-if="!showCreateOrEditRegistrableControllerForm"
                :registrable-controllers-list="{
                    registrableControllers,
                    registrableControllersDropdownList
                }"
                :is-fetching-data="isFetchingData"
                :registrable-controller-blue-print="registrableControllersBluePrint"
                @createRegistrableController="openCreateRegistrableControllerForm"
                @edit="openCreateRegistrableControllerForm"
                @remove="removeRegistrableController"
                @openCreateRegistrableControllerForm="openCreateRegistrableControllerForm"
                @createRegistrableControllerFromDropdown="createRegistrableControllerFromDropdown"
            />

            <div class="mt-2 position-relative">
                <!-- create registrable controller form -->
                <transition name="fade-bottom" mode="out-in">
                    <create-or-edit-registrable-controller-form
                        v-if="showCreateOrEditRegistrableControllerForm"
                        ref="createOrEditRegistrableControllerTest"
                        :data-status="registrableControllerStatus"
                        :data-registrable-controller="registrableControllersBluePrint"
                        @cancel="showCreateOrEditRegistrableControllerForm = false"
                        @createOrEdit="storeOrUpdateRegistrableController"
                    />
                </transition>
            </div>
        </b-card>

        <div class="d-flex justify-content-between mt-3">
            <b-button
                variant="outline-primary"
                @click="$emit('previous')"
            >
                <!-- <img :src="'/icons/left-arrow.svg'" alt="left-arrow" /> -->
                <vector data-type="icons" data-width="16px" data-height="13px" data-name="left-arrow" />
                Previous
            </b-button>

            <b-button
variant="primary" data-test="next"
                :disabled="loading || isFetchingData"
                class=" d-flex justify-content-center next-button align-items-center"
                @click="next"
            >
                Next
                <normal-loader v-if="loading" class="ml-.5" />
                <img v-else :src="'/icons/right-arrow.svg'" class="ml-.5" alt="right-arrow" />
            </b-button>
        </div>
    </b-card>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import { BCard, BButton } from "bootstrap-vue";
import Formation from "@/models/Formation";
import { SHAREHOLDER } from "@/constants/config";
import { errorToast } from '@/views/helpers/toast';
import {
    REGISTRABLE_CONTROLLER_FILL_OUT_ALL_FIELD_ERROR,
    SOMETHING_WENT_WRONG,
} from '@/constants/errors';
import { formatDate } from '@/helpers';
import CreateOrEditRegistrableControllerForm from "./registrable_controllers/RegistrableControllerCreateOrEdit.vue";
import RegistrableControllerIndex from "./registrable_controllers/RegistrableControllerIndex.vue";

export default {
    components:{
        BCard,
        BButton,
        RegistrableControllerIndex,
        CreateOrEditRegistrableControllerForm,
    },

    data(){
        return{
            registrableControllersBluePrint:{
                _id: undefined,
                name: undefined,
                alias: undefined,
                idType: undefined,
                NRIC: undefined,
                shareholderType: {
                    text: SHAREHOLDER.TYPE.INDIVIDUAL,
                    value: SHAREHOLDER.TYPE.INDIVIDUAL,
                },
                nationality: undefined,
                dateOfExpiry: undefined,
                country: undefined,
                dob: undefined,
                email: undefined,
                contactNumber: undefined,
                become_on: undefined,
                sent_on: undefined,
                received_on: undefined,
                cessation_date: undefined,
                remark: undefined,
                uen: undefined,
                legalForm: undefined,
                jurisdiction: undefined,
                statue: undefined,
                registrar: undefined,
                address: undefined,
            },
            registrableControllers: [],
            registrableControllersDropdownList: [],
            registrableControllersKeys: [],
            registrableControllersTotalSteps: 0,
            registrableControllerStatus: undefined,
            showCreateOrEditRegistrableControllerForm: false,

            loading: false,
            isFetchingData: true,
        };
    },

    async created() {
        this.isFetchingData = true;
        this.registrableControllersKeys = Object.keys(this.registrableControllersBluePrint);

        const { users, registrable_controllers }  = await Formation.getDataForRegistrableController();

        registrable_controllers.forEach(registrableController => {
            // when there are no registrable controllers, shareholders data itself becomes the registrable controller
            const key = registrableController.user ? registrableController : registrableController.shareholder;

            let alias = null;
            // first check from registrable controllers
            if (registrableController.shareholder) {
                alias = registrableController.shareholder.alias;
            } else if (registrableController.user.individual_shareholder) {
                alias = registrableController.user.individual_shareholder.alias;
            }

            let shareholderType = SHAREHOLDER.TYPE.INDIVIDUAL;

            // registrableController.shareholder_type ? (registrableController.shareholder_type.includes('Corporate') ? SHAREHOLDER.TYPE.CORPORATE : SHAREHOLDER.TYPE.INDIVIDUAL) : SHAREHOLDER.TYPE.INDIVIDUAL,
            if (registrableController.shareholder_type && (registrableController.shareholder_type.includes('Corporate') || registrableController.shareholder_type.includes('corporate')))
                shareholderType = SHAREHOLDER.TYPE.CORPORATE;
            
            if (registrableController.shareholder_type && (registrableController.shareholder_type.includes('Individual') || registrableController.shareholder_type.includes('individual')))
                shareholderType = SHAREHOLDER.TYPE.INDIVIDUAL;

            this.registrableControllers.push({
                _id: this.generateUniqueId(),
                name: key && key.user.user_info.legal_name,
                alias,
                idType: key.user.user_info?.id_type
                    ? {
                        id: key.user.user_info.id_type?.id,
                        name: key.user.user_info.id_type?.name,
                    }
                    : undefined,
                nationality: (key && shareholderType === SHAREHOLDER.TYPE.INDIVIDUAL) 
                    ? {
                        value: key.user?.user_info?.nationality?.id,
                        text: key.user?.user_info?.nationality?.name,
                    } 
                    : null,
                NRIC: key && key.user.user_info
                    ? key.user.user_info.NRIC
                    : undefined,
                dateOfExpiry: key && key.user.user_info
                    ? formatDate(key.user.user_info.date_of_expiry)
                    : undefined,
                shareholderType: {
                    text: shareholderType,
                    value: shareholderType
                },
                // eslint-disable-next-line no-nested-ternary
                // shareholderType,
                country: (key && shareholderType === SHAREHOLDER.TYPE.CORPORATE) ? key.user.user_info?.country?.id : null,
                dob: key && key.user.user_info
                    ? formatDate(key.user.user_info.DOB)
                    : undefined,
                email: key && key.user
                    ? key.user.email
                    : undefined,
                contactNumber: key && key.user.user_info
                    ? key.user.user_info.contact_number
                    : undefined,
                become_on: formatDate(registrableController.become_on),
                sent_on: formatDate(registrableController.sent_on),
                received_on: formatDate(registrableController.received_on),
                cessation_date: formatDate(registrableController.cessation_date),
                remark: registrableController.remark,
                uen: key.uen,
                legalForm: key.legal_form,
                statue: key.statue ? {
                    id: key.statue.id,
                    name: key.statue.name
                } : undefined,
                jurisdiction: key.jurisdiction ? {
                    id: key.jurisdiction.id,
                    name: key.jurisdiction.name,
                } : undefined,
                registrar: key.registrar ? {
                    id: key.registrar.id,
                    name: key.registrar.name
                } : undefined,
                address: key && key.user.user_info
                    ? key.user.user_info.address
                    : undefined,
            });
        });

        users.forEach(user => {
            if (
                ! this.registrableControllers.find(
                    registrableController => registrableController.email === user.email
                )
            ) {
                let type = SHAREHOLDER.TYPE.INDIVIDUAL;
                if (user.shareholder_type && user.shareholder_type.includes('corporate'))
                    type = SHAREHOLDER.TYPE.CORPORATE;

                this.registrableControllersDropdownList.push({
                    _id: this.generateUniqueId(),
                    name: user?.user_info?.legal_name ?? user.name,
                    idType: user.user_info?.id_type
                        ? {
                            id: user.user_info.id_type?.id,
                            name: user.user_info.id_type?.name,
                        }
                        : undefined,
                    nationality: user.user_info?.nationality 
                        ? {
                            value: user.user_info.nationality?.id,
                            text: user.user_info.nationality?.name,
                        } 
                        : null,
                    dateOfExpiry: user.user_info
                        ? formatDate(user.user_info.date_of_expiry)
                        : undefined,
                    NRIC: user.user_info
                        ? user.user_info.NRIC
                        : undefined,
                    dob: user.user_info
                        ? formatDate(user.user_info.DOB)
                        : undefined,
                    country: user.user_info?.country?.id,
                    email: user.email,
                    contactNumber: user.user_info
                        ? user.user_info.contact_number
                        : undefined,
                    address: user.user_info
                        ? user.user_info.address
                        : undefined,
                    shareholderType: {
                        text: type,
                        value: type
                    }
                });
            }
        });

        this.isFetchingData = false;
    },

    methods:{
        createRegistrableControllerFromDropdown(registrableController) {
            this.openCreateRegistrableControllerForm(registrableController);
        },

        openCreateRegistrableControllerForm(
            registrableController = this.registrableControllersBluePrint,
            status = "create"
        ) {
            // reset Blue Print data
            Object.keys(this.registrableControllersBluePrint).forEach(key => {
                this.registrableControllersBluePrint[key] = registrableController[key] ?? null;
            });

            this.showCreateOrEditRegistrableControllerForm = true;
            this.registrableControllerStatus = status;
        },

        storeOrUpdateRegistrableController(registrableController) {
            if (this.registrableControllerStatus === "edit") {
                this.registrableControllers.forEach(existingRegistrableController => {
                    if (existingRegistrableController._id === registrableController._id) {
                        Object.keys(this.registrableControllersBluePrint).forEach(key => {
                            // eslint-disable-next-line no-param-reassign
                            existingRegistrableController[key] = registrableController[key];
                        });
                    }
                });
            }

            if (this.registrableControllerStatus === "create") {
                // eslint-disable-next-line no-param-reassign
                registrableController._id = this.generateUniqueId();
                this.registrableControllers.push(registrableController);
            }

            this.showCreateOrEditRegistrableControllerForm = false;

            // dropdown registrable controller
            this.registrableControllersDropdownList = this.registrableControllersDropdownList.filter(
                user => user.name !== registrableController.name && user.email && registrableController.email
            );
        },

        removeRegistrableController(registrableController) {
            this.registrableControllers = this.registrableControllers.filter(
                // eslint-disable-next-line no-param-reassign
                existingRegistrableController => existingRegistrableController._id !== registrableController._id
            );
            this.registrableControllersDropdownList.push(registrableController);
        },

        generateUniqueId() {
            return Math.round(Math.random() * 1000);
        },

        async next()
        {
            this.loading = true;
            const {registrableControllers} = this;

            if (! this.validate(registrableControllers))
            {
                errorToast(REGISTRABLE_CONTROLLER_FILL_OUT_ALL_FIELD_ERROR);
                this.loading = false;
                return;
            }

            await Formation.storeRegistrableControllers({
                registrableControllers: this.registrableControllers,
            }).then(() => {
                this.loading = false;
                this.$emit('next');
            }).catch(e => {
                errorToast(SOMETHING_WENT_WRONG);
                this.loading = false;
                console.error('error while trying to store registrable controllers in formation', e);
            });
        },

        validate(registrableControllers)
        {
            const validRegistrableControllerCount = registrableControllers.filter(
                registrableController => this.getTotalSteps(registrableController) === this.getCompletedStepsOf(registrableController)
            ).length;
 
            return validRegistrableControllerCount === registrableControllers.length;
        },

        getTotalSteps(registrableController) { 
            // ignore _id, dateOfExpiry and nationality or country only one will exist at one time
            const bluePrintLength = Object.keys(this.registrableControllersBluePrint).length - (1 + 1 + 1);

            if(registrableController.shareholderType.text === SHAREHOLDER.TYPE.INDIVIDUAL)
                return bluePrintLength - 10;

            return bluePrintLength - 7; 
        },
        
        getCompletedStepsOf(registrableController) {
            if (registrableController.shareholderType.text === SHAREHOLDER.TYPE.INDIVIDUAL)
            {
                return Object.keys(this.registrableControllersBluePrint).filter(
                    key => !!registrableController[key] && !key.includes('alias') && !key.includes('sent_on') && !key.includes('received_on') && !key.includes('cessation_date') && !key.includes('remark') && !key.includes('legalForm') && !key.includes('jurisdiction') && !key.includes('statue') && !key.includes('registrar') && !key.includes('country') && !key.includes('uen') && !key.includes('dateOfExpiry')
                ).length - 1;
            }
            
            return Object.keys(this.registrableControllersBluePrint).filter(
                key => !!registrableController[key] && !key.includes('alias') && !key.includes('sent_on') && !key.includes('received_on') && !key.includes('cessation_date') && !key.includes('remark') && !key.includes('NRIC') && !key.includes('idType') && !key.includes('nationality') && !key.includes('dateOfExpiry')
            ).length - 1;
        },

        // perfectRegistrableLength(registrableController) {  
        //     if( registrableController.shareholderType.text === SHAREHOLDER.TYPE.CORPORATE)
        //         return this.perfectCorporateLength(registrableController);
            
        //     if( registrableController.shareholderType.text === SHAREHOLDER.TYPE.INDIVIDUAL)
        //         return this.perfectIndividualLength(registrableController);

        //     return Object.keys(this.registrableControllersBluePrint).length;
        // },

        // perfectCorporateLength(registrableController){
        //     if(! registrableController.received_on && ! registrableController.cessation_date && ! registrableController.alias )
        //         return Object.keys(this.registrableControllersBluePrint).length - 3; 

        //     if(! registrableController.received_on && ! registrableController.cessation_date)
        //         return Object.keys(this.registrableControllersBluePrint).length - 2;

        //     if(! registrableController.cessation_date && ! registrableController.alias )
        //         return Object.keys(this.registrableControllersBluePrint).length - 2;
            
        //     if(! registrableController.received_on && ! registrableController.alias )
        //         return Object.keys(this.registrableControllersBluePrint).length - 2;
            
        //     if(! registrableController.received_on || ! registrableController.cessation_date || ! registrableController.alias)
        //         return Object.keys(this.registrableControllersBluePrint).length - 1;
                
        //     return Object.keys(this.registrableControllersBluePrint).length;
        // },

        // perfectIndividualLength(registrableController){
        //     if(! registrableController.received_on && ! registrableController.cessation_date && ! registrableController.alias )
        //         return Object.keys(this.registrableControllersBluePrint).length - 8;

        //     if(! registrableController.received_on && ! registrableController.cessation_date)
        //         return Object.keys(this.registrableControllersBluePrint).length - 7;

        //     if(! registrableController.cessation_date && ! registrableController.alias )
        //         return Object.keys(this.registrableControllersBluePrint).length - 7;
            
        //     if(! registrableController.received_on && ! registrableController.alias )
        //         return Object.keys(this.registrableControllersBluePrint).length - 7;
            
        //     if(! registrableController.received_on || ! registrableController.cessation_date || ! registrableController.alias)
        //         return Object.keys(this.registrableControllersBluePrint).length - 6;
                
        //     return Object.keys(this.registrableControllersBluePrint).length - 5;
        // },
    },
};
</script>
